import { apiInterfaceForJson } from "../common/apiManager";

export const fetchSettings = () => {
    return apiInterfaceForJson("/setting/v1/", "GET");
};

export const fetchAvailableSettings = () => {
    return apiInterfaceForJson("/setting/v1/available", "GET");
};

export const searchSettings = (query) => {
    return apiInterfaceForJson("/setting/v1/search", "POST", query);
};

export const getSettingDataById = (settingId) => {
    return apiInterfaceForJson("/setting/v1/" + settingId, "GET");
};

export const createSetting = (settingDetails) => {
    return apiInterfaceForJson("/setting/v1/", "POST", settingDetails);
};

export const updateSetting = (settingDetails) => {
    return apiInterfaceForJson("/setting/v1/", "PUT", settingDetails);
};

export const deleteSetting = (settingDetails) => {
    return apiInterfaceForJson("/setting/v1/delete", "POST", settingDetails);
};

export const updateSystemSettings = (settings) => {
    return apiInterfaceForJson("/setting", "PUT", settings);
};

export const testVoipConnection = (provider, settings) => {
    const requestData = {
        apiKey: settings.apiKey,
        domain: settings.domain,
        accountId: settings.accountId,
        crmId: settings.crmId,
        clientId: settings.clientId,
        c2cId: settings.c2cId, // For backward compatibility
        routeNumber: settings.routeNumber,
        prefix: settings.prefix
    };
    
    return apiInterfaceForJson(`/voip/v1/test/${provider}`, "POST", requestData);
};

export const getVoipStatus = () => {
    return apiInterfaceForJson("/setting/voip-status", "GET");
};

export const downloadBackup = () => {
    return apiInterfaceForJson("/setting/v1/backup/download", "GET");
};

export const uploadBackup = (backupData, mode = "merge") => {
    return apiInterfaceForJson("/setting/v1/backup/upload", "POST", {
        backup: backupData,
        mode: mode
    });
};

// API Key Management Functions
export const getApiKeys = () => {
    return apiInterfaceForJson("/setting/v1/api-keys", "GET");
};

export const createApiKey = (keyData) => {
    return apiInterfaceForJson("/setting/v1/api-keys", "POST", keyData);
};

export const updateApiKey = (keyId, keyData) => {
    return apiInterfaceForJson(`/setting/v1/api-keys/${keyId}`, "PUT", keyData);
};

export const deleteApiKey = (keyId) => {
    return apiInterfaceForJson(`/setting/v1/api-keys/${keyId}`, "DELETE");
};

export const regenerateApiKey = (keyId) => {
    return apiInterfaceForJson(`/setting/v1/api-keys/${keyId}/regenerate`, "POST");
};